import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, search, nullsafe, assertUnreachable, first } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { InfoEntregaComp } from "./info";
import { ListGuiasEntregaNoRx } from "./list";
import {
    onCambiarEntregaRealizada, onBorrarEntrega, obtenerInfoEntrega, onFinalizarEntrega,
    obtenerContactos, puedeFinalizar, obtenerEntrega
} from "./logic";
import { syncViaje } from "../logic";
import { PagoEntregaComp } from "./pago";

import { FinalizarEntregaEdit, RecordarAcusesModal } from "./finalizar";

export interface Props {
    value: models.ViajeAppIniciado;
    onChange: (x: models.ViajeAppIniciado) => Promise<void>;
    claveEntrega: string;
}

const FinalizarButton = kea.defaultProps(kea.Button, { children: "Finalizar", iconClass: fa("check"), style: "success" });
const CancelarButton = kea.defaultProps(kea.Button, { children: "Cancelar", iconClass: fa("times"), style: "danger" });

class EntregaRealizadaFormNoRx extends React.PureComponent<Props> {
    value = (x: Props) => x.value;
    clave = (x: Props) => x.claveEntrega;
    entrega = createSelectorRx(this.value, this.clave, obtenerEntrega);
    contactos = createSelectorRx(this.value, this.clave, obtenerContactos);
    modalManager = kea.createModalManager();
    onChange = (x: models.EntregaRealizadaViajeAppModel) => {
        const oldValue = this.props.value;
        const info = obtenerInfoEntrega(this.props.value, this.props.claveEntrega);

        //Si la entrega esta finalizada, esta ya es de solo lectura
        if (info.Finalizado) return;

        const nextValue = onCambiarEntregaRealizada(oldValue, this.props.claveEntrega, x);
        this.props.onChange(nextValue);
    }

    onContactoChange = (id: number) => {
        const oldValue = this.entrega(this.props);
        const nextValue: models.EntregaRealizadaViajeAppModel = {
            ...oldValue,
            IdContactoRecibio: id
        };
        this.onChange(nextValue);
    }

    onNombreContactoChange = (nombre: string) => {
        const info = obtenerInfoEntrega(this.props.value, this.props.claveEntrega);
        if (!info.Finalizado) {
            const oldValue = this.entrega(this.props);
            const nextValue: models.EntregaRealizadaViajeAppModel = {
                ...oldValue,
                NombreContactoRecibio: nombre
            };
            this.onChange(nextValue);
        }
    }

    onRegresar = () => {
        history.go("../");
    }

    onCancelar = async () => {
        const info = obtenerInfoEntrega(this.props.value, this.props.claveEntrega);
        //Si la entrega esta finalizada, esta ya es de solo lectura
        if (info.Finalizado) {
            await kea.message("Entrega finalizada", "No se puede cancelar una entrega que ya finalizó", "warning");
            return;
        }

        if (await kea.yesno("Cancelar entrega", "¿Cancelar esta entrega?")) {
            const nextValue = onBorrarEntrega(this.props.value, this.props.claveEntrega);
            this.props.onChange(nextValue);
            history.go("../");
        }
    }
    onFinalizar = async () => {
        const validacion = puedeFinalizar(this.props.value, this.props.claveEntrega);

        if (validacion != true) {
            switch (validacion) {
                case "faltaContacto":
                    await kea.message("Contacto", "El contacto es obligatorio", "error");
                    break;
                case "faltaMotivo":
                    await kea.message("Motivo de rechazo", "Alguna guia rechazada no tiene el motivo especificado", "error");
                    break;
                case "saldoInsuficiente":
                    await kea.message("Saldo insuficiente", "El cliente no tiene suficiente saldo para pagar la entrega a crédito", "error");
                    break;
                case "creditoBloqueado":
                    await kea.message("Linea de crédito bloqueada", "El cliente tiene su linea de crédito bloqueada", "error");
                    break;
                case "sinGuias":
                    await kea.message("Sin guias", "Seleccione por lo menos una guia para entregar/rechazar", "error");
                    break;
                default: assertUnreachable(validacion);
            }
            return;
        }
        const info = obtenerInfoEntrega(this.props.value, this.props.claveEntrega);
        //Si la entrega esta finalizada, esta ya es de solo lectura
        if (info.Finalizado) {
            await kea.message("Entrega finalizada", "La entrega ya esta finalizada", "warning");
            return;
        }

        //Recordar al usuario de los acuses
        if (info.AcusesEntrega.length > 0) {
            const ok = await this.modalManager.showModal(RecordarAcusesModal, info.AcusesEntrega, undefined);
            if (!ok.result) return;
        }

        //Pedir la firma del cliente
        const result = await this.modalManager.showModal(FinalizarEntregaEdit, undefined, { Segmentos: [] } as models.FirmaModel);

        if (result.result) {
            const next = onFinalizarEntrega(this.props.value, this.props.claveEntrega, result.value);
            await this.props.onChange(next);
            const syncResult = await syncViaje();
            if (syncResult == true) {
                await kea.message("Entrega finalizada", "Se compartieron los datos con el servidor", "success");
            }
            else {
                await kea.message("Entrega finalizada, sin conexión", "Se almacenaron los datos en el dispositivo ya que no hay conexión", "warning");
            }
        }
    }

    render() {
        const entrega = this.entrega(this.props);
        return (
            <div>
                {
                    entrega != null ?
                        (() => {
                            const contactos = this.contactos(this.props);
                            return (
                                <div>
                                    <kea.Title titulo="Entrega realizada" onRegresar={this.onRegresar} >
                                        <CancelarButton onClick={this.onCancelar} />
                                        <FinalizarButton onClick={this.onFinalizar} />
                                    </kea.Title>

                                    <InfoEntregaComp state={this.props.value} claveEntrega={this.props.claveEntrega} />

                                    <kea.Select
                                        label="Contacto recibió"
                                        items={contactos.map(x => ({ label: x.Nombre, value: x.IdRegistro }))}
                                        value={entrega.IdContactoRecibio}
                                        onChange={this.onContactoChange}
                                    />
                                    {
                                        entrega.IdContactoRecibio == null &&
                                        <kea.Text
                                            label="Nombre nuevo contacto recibió"
                                            value={entrega.NombreContactoRecibio}
                                            onChange={this.onNombreContactoChange}
                                            disableFastInput
                                        />
                                    }


                                    <PagoEntregaComp state={this.props.value} claveEntrega={this.props.claveEntrega} onChange={this.onChange} />
                                    <ListGuiasEntregaNoRx state={this.props.value} value={entrega} onChange={this.onChange} />
                                </div>
                            );
                        })()
                        :
                        <div className="alert alert-warning">
                            <label>Esta entrega ya no existe</label>
                        </div>
                }

                {this.modalManager.component}
            </div>
        )
    }
}

export const EntregaRealizadaFormRx = componentToRx(EntregaRealizadaFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeapp/entrega/form.tsx